import React from 'react'
import * as styles from './Accordion.module.scss'
import getClassNameFactory from 'util/getClassNameFactory'

const getClassName = getClassNameFactory('Accordion', styles)

const Accordion = ({
  items,
  onToggle,
  className = '',
  tabLabelClassName = '',
  tabContentClassName = '',
  showArrow = true,
}) => {
  return (
    <div className={className || getClassName()}>
      {items.map((item, index) => (
        <div key={index} className={getClassName('tab')}>
          <div
            className={tabLabelClassName || getClassName(['tabLabel'])}
            onClick={onToggle ? () => onToggle(index) : undefined}
            role="button"
            tabIndex={0}
          >
            {item.label}
            {showArrow && (
              <span
                className={getClassName({
                  arrow: true,
                  arrowOpen: item.isOpen,
                })}
              />
            )}
          </div>
          <div
            className={getClassName(
              {
                tabContent: true,
                expanded: item.isOpen,
              },
              tabContentClassName,
            )}
          >
            {item.content}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Accordion
